export const BANNER_COLORS = [
  { value: 'orange', label: 'Orange', gradient: 'from-orange-500 to-orange-600', swatch: 'bg-orange-500' },
  { value: 'blue', label: 'Bleu', gradient: 'from-blue-600 to-blue-700', swatch: 'bg-blue-600' },
  { value: 'green', label: 'Vert', gradient: 'from-green-500 to-green-600', swatch: 'bg-green-500' },
  { value: 'navy', label: 'Bleu marine', gradient: 'from-[#1e3a5f] to-[#2d4a6f]', swatch: 'bg-[#1e3a5f]' },
  { value: 'red', label: 'Rouge', gradient: 'from-red-500 to-red-600', swatch: 'bg-red-500' },
  { value: 'purple', label: 'Violet', gradient: 'from-violet-600 to-violet-700', swatch: 'bg-violet-600' },
  { value: 'dark', label: 'Anthracite', gradient: 'from-gray-800 to-gray-900', swatch: 'bg-gray-800' },
];

export const bannerGradient = (color) => (BANNER_COLORS.find(c => c.value === color) || BANNER_COLORS[0]).gradient;
